import { makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { ActivityItem } from '@spotify/plugin-confidence-activity-react';

import { Variant } from './types';

const useStyles = makeStyles({
  image: {
    width: '100%',
    borderRadius: 'var(--encore-corner-radius-smaller)',
  },
  addedImage: {
    border: '1px solid var(--essential-positive)',
  },
  removedImage: {
    boxShadow: '0 0 0 1px var(--text-subdued)',
    opacity: 0.6,
  },
});

export const ImageSection = ({
  oldVariant,
  newVariant,
}: {
  oldVariant?: Variant;
  newVariant?: Variant;
}) => {
  const classes = useStyles();

  if (!oldVariant) {
    // create variant case

    if (newVariant?.imageUri) {
      return (
        <ActivityItem.Section label="Image">
          <img src={newVariant.imageUri} alt="New" className={classes.image} />
        </ActivityItem.Section>
      );
    }

    return null;
  }

  if (!newVariant) {
    // remove variant case

    if (oldVariant?.imageUri) {
      return (
        <ActivityItem.Section label="Image">
          <img src={oldVariant.imageUri} alt="Old" className={classes.image} />
        </ActivityItem.Section>
      );
    }

    return null;
  }

  const oldImageUri = oldVariant?.imageUri;
  const newImageUri = newVariant?.imageUri;

  if (!oldImageUri && !newImageUri) {
    return null;
  }

  if (oldImageUri === newImageUri) {
    return (
      <ActivityItem.Section label="Image">
        <img src={oldImageUri} alt="Variant" className={classes.image} />
      </ActivityItem.Section>
    );
  } else if (oldImageUri && newImageUri) {
    return (
      <ActivityItem.Section label="Image">
        <img
          src={oldImageUri}
          alt="Old"
          className={classNames(classes.image, classes.removedImage)}
        />
        <img
          src={newImageUri}
          alt="New"
          className={classNames(classes.image, classes.addedImage)}
        />
      </ActivityItem.Section>
    );
  } else if (oldImageUri) {
    return (
      <ActivityItem.Section label="Image">
        <img
          src={oldImageUri}
          alt="Old"
          className={classNames(classes.image, classes.removedImage)}
        />
      </ActivityItem.Section>
    );
  } else if (newImageUri) {
    return (
      <ActivityItem.Section label="Image">
        <img
          src={newImageUri}
          alt="New"
          className={classNames(classes.image, classes.addedImage)}
        />
      </ActivityItem.Section>
    );
  }

  return null;
};
